export default __webpack_public_path__ + "static/media/Hive Hammer.e39fdc3d.jpg";